import React, { useContext } from 'react';
import './VendorHeader.css';
import VendorCard from '../Card/VendorCard.jsx';
import PropTypeShapes from '../../../services/Constants/PropTypeShapes.jsx';
import { Vendor } from '../../../services/Constants/ObjectDefinitions.js';
import ExtraValueTryNowBox from '../../../pages/ExtraValueTryNowBox/ExtraValueTryNowBox.jsx';
import { SubscriptionDetailsContext } from '../../../services/context/SubscriptionDetailsContext.js';
import ClubIcon from '../../../assets/ClubIcon.png';

/**
 * @param {object} props - the props of the component
 * @param {Vendor} [props.vendor] - the vendor to show
 * @param {boolean} [props.noVouchersPresent] - whether all vouchers are empty
 * @returns {JSX.Element} VendorHeader component
 */
export default function VendorHeader({ vendor, noVouchersPresent }) {
  const validityTypes = new Set(vendor?.vouchers?.map(voucher => voucher.redemption.validity));
  const redemptionTypes = new Set(vendor?.vouchers?.map(voucher => voucher.redemption.type));
  const isEmpty = !vendor;
  const subscriptionStatus = useContext(SubscriptionDetailsContext);
  const clubVoucherPresent = localStorage.getItem('clubVoucherPresent') || false;

  /**
   *
   * @param validityTypes
   * @param redemptionTypes
   * @param noVouchersPresent
   * @param clubVoucherPresent
   */
  function renderClubVoucherMessage() {
    if (validityTypes.size > 0 && redemptionTypes.size > 0 && !noVouchersPresent && clubVoucherPresent) {
      return (
        <span className='text-padding'>
          All vouchers valid for 3 years, multi-redemption.
          <br />
          Voucher limit refreshes in 30 days
        </span>
      );
    }

    return null;
  }

  /**
   *
   * @param subscriptionStatus
   * @param clubVoucherPresent
   * @param noVouchersPresent
   */
  function renderClubTile() {
    if (!clubVoucherPresent && subscriptionStatus?.isSubscribed && !noVouchersPresent) {
      return (
        <div className='club-tile'>
          <img
            src={ ClubIcon }
            alt='Club'
            className='club-icon'
          />
          <span className='club-text'>
            <p>You&apos;ve used all of your Club allocation for this month.</p>
            <p>Keep saving with these great standard deals below</p>
          </span>
        </div>
      );
    }

    return null;
  }

  return (
    <header className='vendor-header v-container-h'>
      <VendorCard
        vendor={ vendor }
        hideInfo={ true }
      />
      {!subscriptionStatus?.isSubscribed && <ExtraValueTryNowBox />}
      <h3 className={ isEmpty ? 'empty skeleton-loader' : 'vendor-style' }>
        {vendor?.name}
      </h3>
      {renderClubVoucherMessage()}
      {renderClubTile()}
      {
        isEmpty && (
          <>
            <p className='empty skeleton-loader' />
            <p className='empty skeleton-loader' />
          </>
        )
      }
    </header>
  );
}

VendorHeader.propTypes = {
  vendor: PropTypeShapes.vendor,
  noVouchersPresent: PropTypeShapes.bool,
};
